<template>
  <div class="q-pa-md q-gutter-sm">
    <q-dialog v-model="confirm" persistent transition-show="scale" transition-hide="scale">
      <q-card style="width: 300px">
        <div class="alert-box">
          <div class="alert-title">ALERT!!</div>
          <div class="alert-content">
            <div class="alert-text">
              Are you sure to delete
              <span class="bold">{{selectedCompany.name}}</span> company ?
            </div>
            <div class="alert-actions">
              <q-btn flat @click="reset">CANCEL</q-btn>
              <q-btn flat :loading="loading" label="OK" @click="remove">
                <template v-slot:loading>
                  <q-spinner-facebook />
                </template>
              </q-btn>
            </div>
          </div>
        </div>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import axios from "../axios/index";
export default {
  data() {
    return {
      loading: false
    };
  },
  methods: {
    reset() {
      this.selectedCompany = {};
      this.confirm = false;
    },
    async remove() {
      try {
        this.loading = true;
        await axios.delete(`company/${this.selectedCompany.id}`);
        this.$store.commit("company/DELETE_COMPANY", this.selectedCompany.id);
        this.$store.commit("vehicle/DELETE_SELECTED_VEHICLE",this.selectedCompany.id)
        this.$store.commit("profit/DELETE_SELECTED_VEHICLE",this.selectedCompany.id)
        this.selectedCompany = {};
        this.confirm = false;
        this.$q.notify({
          message: "Company deleted.",
          timeout: 250,
          position: "top-right",
          progress: true,
          type: "positive"
        });
      } catch (error) {
        this.$q.notify({
          message: "We can not delete company.Something wrong.",
          timeout: 250,
          position: "top-right",
          progress: true,
          type: "negative"
        });
      } finally {
        this.loading = false;
      }
    }
  },
  computed: {
    confirm: {
      get() {
        return this.$store.state.company.confirm;
      },
      set(val) {
        this.$store.commit("company/SET_CONFIRM", val);
      }
    },
    selectedCompany: {
      get() {
        return this.$store.state.company.selectedCompany;
      },
      set(val) {
        this.$store.commit("company/SET_SELECTED_COMPANY", {});
      }
    }
  }
};
</script>